<template>
  <div>
    <h1>{{ $t("optima.contractor") }} Optima</h1>
    <optima-menu />
    <v-row>
      <v-col cols="12" md="4">
        <ajax-single-file :model.sync="fileId" :label="$t('optima.importEmployeeFromXls')" accept="application/xls" :items.sync="items" />
      </v-col>
      <v-col class="mt-3">
        <v-btn color="primary" @click="load">{{ $t("global.load") }}</v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="contractors"
      :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
      class="elevation-1"
      hide-default-footer
    >
      <template #item="props">
        <tr>
          <td class="text-left" v-for="item of headers" :key="item.text">
            {{ props.item[item.text] }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import OptimaMenu from "../../components/Optima/OptimaMenu";
import AjaxSingleFile from "../../components/CustomInputComponents/AjaxSingleFile";
export default {
  name: "OptimaSettingsContractorView",
  components: { AjaxSingleFile, OptimaMenu },
  data: () => ({
    fileId: null,
    items: [],
    contractors: []
  }),
  computed: {
    headers() {
      if (this.contractors.length === 0) {
        return [{ text: this.$t("optima.notImportedYet") }];
      }
      let header = [];
      for (let key in this.contractors[0]) {
        header.push({ text: key, value: key });
      }
      return header;
    }
  },
  methods: {
    load() {
      this.axios.post("optima/import-contractor", { fileId: this.fileId }).then(() => {
        this.downloadContractors();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    },
    downloadContractors() {
      this.axios.get("optima/get-contractor").then(response => {
        this.contractors = response.data;
      });
    }
  },
  created() {
    this.downloadContractors();
  }
};
</script>

<style scoped></style>
